<div [class]="'attachment-subtitle'">
  {{ 'LIB_ORDERS.COMMON.ORDER_DETAILS.ADMIN_ATTACHMENTS_SUBTITLE' | translate }}
</div>
@if (files && files.length > 0) {
  <div>
    <glxy-uploader-list [files]="files" (fileDeleted)="onFileDeleted($event)"></glxy-uploader-list>
  </div>
} @else {
  <div class="no-files">
    {{ 'LIB_ORDERS.COMMON.ORDER_DETAILS.EMPTY_ATTACHMENTS' | translate }}
  </div>
}
@if (!editingDisabled) {
  <div [class]="'edit-button'">
    <button mat-stroked-button color="primary" (click)="onClickAdd()">
      + {{ 'LIB_ORDERS.COMMON.ORDER_DETAILS.UPLOAD_ATTACHMENTS' | translate }}
    </button>
  </div>
}
